import request from '@/utils/ajax';

export function deleteTmpMsgLog(data){
  return request({
    url: `/wx/manage/templateMsgLog/delete`,
    method: 'post',
    data: data
  });
}
